module.exports = __webpack_public_path__ + "img/37.2a84fd99.jpg";